export default "__VITE_ASSET__DtV1k80T__"